// extracted by mini-css-extract-plugin
module.exports = {"form_container":"SignInScreen_form_container__3LrCo","form":"SignInScreen_form__oqGB9","signin_btn":"SignInScreen_signin_btn__2doDx"};